import { render } from "./register-page.vue?vue&type=template&id=d7a56030&scoped=true"
import script from "./register-page.vue?vue&type=script&lang=js"
export * from "./register-page.vue?vue&type=script&lang=js"

import "./register-page.vue?vue&type=style&index=0&id=d7a56030&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7a56030"]])

export default __exports__